import { useMutation, useQueryClient } from '@tanstack/react-query';
import postCameraViolation from 'Api/monitoring/postCameraViolation';

import postCameraViolationPayload from './model/request/postCameraViolationPayload';

const usePostCameraViolation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formData) => {
      const payload = await postCameraViolationPayload(formData);

      const result = await postCameraViolation(payload);

      return result;
    },
    onSuccess: async () => queryClient.invalidateQueries({ queryKey: ['daily-log'] }),
  });
};

export default usePostCameraViolation;
